import { render, staticRenderFns } from "./PreviewImageAd.vue?vue&type=template&id=4387bcd0"
import script from "./PreviewImageAd.vue?vue&type=script&lang=js"
export * from "./PreviewImageAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports